import { cloneDeep } from 'lodash-es';

const settings = cloneDeep(window._HC_SETTINGS || {});

export function getSetting(key) {
  return settings[key];
}

export const currentEnvironment = process.env.NODE_ENV;
export const isProduction = currentEnvironment === 'production';
export const isDevelopment = currentEnvironment === 'development';

export function getAuthorizeURL() {
  return `${getSetting('URL_SSO')}/authorize?client_id=${getSetting('SSO_CLIENT_ID')}&response_type=token`;
}

const encodeString = btoa;
const decodeString = atob;

const k = (key) => {
  return `${(getSetting('LOCAL_STORAGE_PREFIX'))}_${key}`.toUpperCase().replace('-', '_');
};

export function hasLocalStorage(key) {
  return window.localStorage.getItem(k(key)) !== null;
}

export function getLocalStorage(key) {
  if (!hasLocalStorage(key)) {
    return null;
  }

  const value = window.localStorage.getItem(k(key));

  return JSON.parse(decodeString(value));
}

export function setLocalStorage(key, value) {
  window.localStorage.setItem(k(key), encodeString(JSON.stringify(value)));
}

export function removeLocalStorage(key) {
  window.localStorage.removeItem(k(key));
}

export function buildDelayedFunction(delayFunction, clearDelayFunction) {
  return function (handler, delay, immediate = false, clearOnDestroy = true) {
    if (immediate) {
      handler();
    }

    const id = delayFunction(handler, delay);

    if (clearOnDestroy) {
      this.$once('hook:beforeDestroy', function () {
        clearDelayFunction(id);
      });
    }

    return id;
  };
}
